import { HTMLAttributes, JSX, PropsWithChildren } from 'react'
import { cn } from '@/utilities/ui'
import { Button } from '@/components/ui/button'

export function OutlineButton({ children, className, ...rest }: PropsWithChildren<HTMLAttributes<HTMLButtonElement>>): JSX.Element {
    return (
        <Button
            variant='outline'
            className={cn('hover:border hover:border-black hover:text-black dark:hover:text-white dark:hover:border-white', className)}
            {...rest}
        >
            {children}
        </Button>
    )
}
